export default __webpack_public_path__ + "static/media/calendar.f5b993d7.svg";